import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * A dismissible banner that shows a warning when user is outside the service area
 */
const LocationBanner = ({ city, state, country, isVisible }) => {
  const [dismissed, setDismissed] = useState(false);

  if (!isVisible || dismissed) {
    return null;
  }

  // Build a more robust location display that handles missing fields
  let locationText = '';
  
  // If we have a city, use it
  if (city) {
    locationText = city;
    
    // Add state if available (for US locations)
    if (state) {
      locationText += `, ${state}`;
    }
    // Add country if available and not US (for international locations)
    else if (country && country !== 'US' && country !== 'USA') {
      locationText += `, ${country}`;
    }
  }
  // Fallback to state or country if no city
  else if (state) {
    locationText = state;
  }
  else if (country && country !== 'US' && country !== 'USA') {
    locationText = country;
  }
  
  // Final fallback if all location info is missing
  if (!locationText) {
    locationText = 'your location';
  }

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <div className="location-banner">
      <p>We do not currently have stores available near {locationText}</p>
      <button 
        onClick={handleDismiss} 
        className="dismiss-button"
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

LocationBanner.propTypes = {
  city: PropTypes.string.isRequired,
  state: PropTypes.string,
  country: PropTypes.string,
  isVisible: PropTypes.bool.isRequired
};

export default LocationBanner;
